import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

import FormControlButtons from './formControlButtons';
import Replies from '../Replies';
import AlertComponent from '../../../../../components/Alert';
import TipTap from '../../../../../components/TipTap';

import { sendMessageFunc } from '../../helpers';
import { convertStringToHtml, ticketToolbar } from '../../../helpers';

const TicketBody = ({ setError, id, globalError, prepareConfirm, access, replies, cdn }) => {
  const formRef = useRef(null);
  const inputRef = useRef(null);
  const uploaderRef = useRef(null);
  const filesList = useRef([]);

  const dispatch = useDispatch();

  const isFetching = useSelector((state) => state.tickets.replyFetching);

  const onChangeFiles = (files) => {
    filesList.current = files;
  };

  const getInitValue = () => {
    if (window.localStorage && window.localStorage.getItem && window.localStorage.getItem(id)) {
      return window.localStorage.getItem(id);
    }
    return '';
  };
  const [content, setContent] = useState(getInitValue());

  const handleSubmit = async () => {
    setError('');
    try {
      if (window.localStorage && window.localStorage.removeItem && window.localStorage.getItem(id)) {
        window.localStorage.removeItem(id);
      }
      await sendMessageFunc(dispatch, id, content, filesList.current);
    } catch (error) {
      setError(error);
    }
  };

  const onChangeMessage = (content) => {
    if (window.localStorage && window.localStorage.setItem) {
      try {
        window.localStorage.setItem(id, content);
      } catch (error) {
        // Error
        console.error(error);
      }
    }
    setContent(content);
  };

  const onSelectReply = (reply) => {
    const html = convertStringToHtml(reply.body);
    inputRef.current.pasteHtml(html);
  };

  const onUploadFiles = (files) => {
    uploaderRef.current?.onFilesChange({ target: { files } });
  };

  return (
    <div className="list-group-item">
      <Row>
        <Col xs={12}>
          {globalError ? <AlertComponent type="danger" text={globalError} /> : null}
          <div className="ticket-editor">
            <div className="ticket-editor__replies">
              <Replies onSelectReply={onSelectReply} replies={replies} />
            </div>
            <TipTap
              toolbar={ticketToolbar}
              content={content}
              ref={inputRef}
              onChange={onChangeMessage}
              onPaste={onUploadFiles}
              onDrop={onUploadFiles}
            />
          </div>
        </Col>

        {access?.show_buttons && (
          <FormControlButtons
            formRef={formRef}
            uploaderRef={uploaderRef}
            onSubmit={handleSubmit}
            isFetching={isFetching}
            id={id}
            prepareConfirm={prepareConfirm}
            setError={setError}
            access={access}
            cdn={cdn}
            onChangeFiles={onChangeFiles}
          />
        )}
      </Row>
    </div>
  );
};

TicketBody.propTypes = {
  setError: PropTypes.func,
  globalError: PropTypes.any,
  id: PropTypes.number,
  prepareConfirm: PropTypes.func,
  access: PropTypes.object,
  replies: PropTypes.array,
  cdn: PropTypes.object,
};

export default TicketBody;
